/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './components/App.tsx'

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(<App />)
